// extracted by mini-css-extract-plugin
module.exports = {"header":"AppHeader_header__X9aJA","heading":"AppHeader_heading__3z9Iu","lang":"AppHeader_lang__3Jtnn"};